import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'
// import Typography from '@mui/material/Typography';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import ContentCard from '../components/Cards/ContentCard';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';
import Accordions from '../components/Accordions/Accordions';

export default function FemaleIntimateWellnessOne() {
    const { t } = useTranslation();

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description:  t('female_intimate_wellness_one.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description:  t('female_intimate_wellness_one.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description:  t('female_intimate_wellness_one.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description:  t('female_intimate_wellness_one.sessions'),
        }
    ];

    const accodirons = [
        {
            title: t('what'),
            content: t('female_intimate_wellness_one.what')
        },
        {
            title: t('how'),
            content: t('female_intimate_wellness_one.how')
        },
        {
            title: t('benefits'),
            content: t('female_intimate_wellness_one.benefits')
        },
        {
            title: t('zone'),
            content: t('female_intimate_wellness_one.zone')
        },
        {
            title: t('pairs'),
            content: t('female_intimate_wellness_one.pairs')
        },
        {
            title: t('when_expected_results'),
            content: t('female_intimate_wellness_one.when_expected_result')
        },
        {
            title: t('results'),
            content: t('female_intimate_wellness_one.results')
        },
    ]

    return (
        <Box>
            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 1.png`} height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: t('bodyherapies'),
                        title: t('female_intimate_wellness_one.mainTitle'),
                        description: t('female_intimate_wellness_one.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMFEMME 360°")}`,
                        // learnUrl: "/"
                        price: `${t('price_session')} €150\n${t('price_package')} 6 ${t('price_seanc')}: €750`,

                        doctorIncluded: true
                    }}
                />
            </Box>


            <Box marginTop={{md: '151px', xs: '50px'}} position={'relative'} height={{md: '426px', xs: 'auto'}}>
                <Box component={'span'} sx={{ display: 'block', clipPath: {md: 'polygon(50% 100%, 51% 60%, 100% 60%, 0 60%, 49% 60%)', xs: 'polygon(50% 100%, 55% 60%, 100% 60%, 0 60%, 45% 60%)'}, position: 'absolute', left: 0, width: '100%', backgroundColor: '#FFF', top: '-33px', height: '56px' }}></Box>
                <Box bgcolor={'#f0f0ef'} paddingTop={{md: '120px', xs: '60px'}} paddingBottom={{md: '104px', xs: '40px'}}>
                    <Box className='generalContainer' marginX={'auto'}>
                        <SmallCards data={data2} />
                    </Box>
                </Box>
            </Box>
            
            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMFEMME 360°")}`,
                            type: t('female_intimate_wellness_one.tech'),
                            // learn: '/',
                            title: t('female_intimate_wellness_one.techTitle'),
                            size: { md: 8, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/ALMA3.png`,
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            imageSize: {md: 4, xs: 12},
                            description: t('female_intimate_wellness_one.techDesc')
                        }}
                        bgColor={'rgba(30, 53, 61, 1)'}
                    />
                </Box>
            </Box>

             <Grid container gap={{ md: '80px', xs: '30px' }} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{ md: '100px', xs: '50px' }}>
                    <Grid size={12}>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'}>{t('additional_information')}</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Accordions data={accodirons} />
                    </Grid>
                </Grid>



             <Box marginTop={{md: '80px', xs: ''}} marginBottom={{md: '243px', xs: ''}}>
                 

                  
                  
                </Box>
        </Box>
    );
}